module.exports = __webpack_public_path__ + "img/qr-code-white.6d0e26cd.svg";